import { Components, Theme } from '@mui/material'

export const MuiFormControlLabel: Components<Omit<Theme, 'components'>>['MuiFormControlLabel'] = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      ...theme.typography['futureTheme.body-medium'],
      color: theme.palette.futureTheme.text.default,
      '&:has(.MuiCheckbox-root)': {
        // Negative margin to align left edge of checkbox with left edge of other elements
        marginLeft: theme.spacing(-2),
      },
      '& .MuiFormControlLabel-label.Mui-disabled': {
        color: theme.palette.futureTheme.text.default,
      },
    }),
  },
}
